/**
 * Detecta si un error corresponde a la falla de descarga de un chunk/módulo dinámico
 * ocasionado por un nuevo despliegue en producción con hashes de archivo renovados.
 */
export function isChunkLoadError(error) {
  if (!error) return false;
  const msg = (error?.message || error?.toString() || '').toLowerCase();
  return (
    msg.includes('failed to fetch dynamically imported module') ||
    msg.includes('error loading dynamically imported module') ||
    msg.includes('importing a module script failed') ||
    msg.includes('loading chunk') ||
    msg.includes('chunkloaderror')
  );
}

/**
 * Recarga la aplicación automáticamente si no se ha recargado en los últimos cooldownMs.
 * Devuelve true si inició la recarga, o false si ya se recargó recientemente.
 */
export function triggerChunkReload(cooldownMs = 8000) {
  try {
    const lastReload = parseInt(sessionStorage.getItem('last_chunk_reload') || '0', 10);
    const now = Date.now();
    if (now - lastReload > cooldownMs) {
      sessionStorage.setItem('last_chunk_reload', String(now));
      window.location.reload();
      return true;
    }
  } catch {
    // Si cookies/sessionStorage están bloqueados por el navegador
  }
  return false;
}
